var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9619 13.0183C19.9619 13.7089 20.2362 14.3712 20.7245 14.8595C21.2128 15.3478 21.8751 15.6221 22.5657 15.6221C23.2563 15.6221 23.9185 15.3478 24.4068 14.8595C24.8951 14.3712 25.1695 13.7089 25.1695 13.0183C25.1695 12.3278 24.8951 11.6655 24.4068 11.1772C23.9185 10.6889 23.2563 10.4146 22.5657 10.4146C21.8751 10.4146 21.2128 10.6889 20.7245 11.1772C20.2362 11.6655 19.9619 12.3278 19.9619 13.0183ZM23.8676 19.0938H21.2638C21.0251 19.0938 20.8298 19.2891 20.8298 19.5278V34.2825C20.8298 34.5212 21.0251 34.7164 21.2638 34.7164H23.8676C24.1063 34.7164 24.3015 34.5212 24.3015 34.2825V19.5278C24.3015 19.2891 24.1063 19.0938 23.8676 19.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.fa2d0cdf59e9eff64245979d755cbb55.svg";
export { ForwardRef as ReactComponent };